import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Form, Field } from 'react-final-form';
import { Button, Modal } from 'react-bootstrap';
import cx from 'classnames';
import './CreateAlertModal.less';

const intervalOptions = [
  { value: -1, label: 'Save/Pause' },
  { value: 3600, label: 'Hourly' },
  { value: 86400, label: 'Daily' },
  { value: 604800, label: 'Weekly' },
];

const getIntervalOptions = advancedSearchFilterTemplate => {
  // Petitions, Schedules and Cases alerts shouldn't have Hourly option
  if (advancedSearchFilterTemplate && ['extended', 'schedules', 'case_lookup'].includes(advancedSearchFilterTemplate)) {
    return intervalOptions.filter(option => option.value !== 3600);
  }
  // Case activity alerts shouldn't have Hourly and Weekly options
  if (advancedSearchFilterTemplate && ['case_activity'].includes(advancedSearchFilterTemplate)) {
    return intervalOptions.filter(option => option.value !== 3600 && option.value !== 604800);
  }

  return intervalOptions;
};

const onSubmit = (values, onSave) => {
  onSave(values);
};

const hasError = meta => meta.error && meta.submitFailed;

export const CreateAlertModal = ({
  onSave,
  show,
  onClose,
  advancedSearch: {
    filter: { template },
    alert: { data = {} },
  },
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <div className="create-alert-modal">
        <Form
          onSubmit={values => onSubmit(values, onSave)}
          initialValues={{ ...data, save_as_new: !(data && data.name) }}
          validate={values => {
            const errors = {};
            if (!values.name) {
              errors.name = 'Name is required';
            }
            if (values.delivery !== 'webhook') {
              if (
                !intervalOptions.some(
                  option => values.notify_interval && option.value.toString() === values.notify_interval.toString()
                )
              ) {
                errors.notify_interval = 'Notification Interval is required';
              }
            }
            return errors;
          }}
          render={({ handleSubmit, values }) => (
            <form onSubmit={handleSubmit} id="ir-alerts-edit-form">
              <Modal.Header closeButton>
                <Modal.Title>{data.id ? 'Edit Alert' : 'Add Alert'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Field name="name">
                    {({ input, meta }) => {
                      const errorClass = cx({ error: hasError(meta) });

                      return (
                        <div className="form-item" id="edit-name-wrapper">
                          <label htmlFor="edit-name" className={errorClass}>
                            Name:
                            <span className="form-required" title="This field is required.">
                              *
                            </span>
                          </label>
                          <input
                            {...input}
                            type="text"
                            id="edit-name"
                            maxLength="50"
                            value={values.name || ''}
                            className={`form-text ${errorClass}`}
                          />
                          {hasError(meta) && <span className="error description">{meta.error}</span>}
                        </div>
                      );
                    }}
                  </Field>
                  <Field name="notify_interval">
                    {({ input: { onChange, ...rest }, meta }) => {
                      const errorClass = cx({ error: hasError(meta) });

                      return (
                        <div className="form-item" id="edit-notify-interval-wrapper">
                          <label htmlFor="edit-notify-interval" className={errorClass}>
                            Notification interval:
                            <span className="form-required" title="This field is required.">
                              *
                            </span>
                          </label>
                          <Select
                            {...rest}
                            onChange={({ label, value }) => {
                              values.notify_interval_label = label;
                              onChange(value);
                            }}
                            options={getIntervalOptions(template)}
                            clearable={false}
                            id="edit-notify-interval"
                            className={`form-select ${errorClass}`}
                          />
                          {hasError(meta) && <span className="error description">{meta.error}</span>}
                        </div>
                      );
                    }}
                  </Field>
                  {data.id && (
                    <div className="save-as-new">
                      <label>Save as new alert instead</label>
                      <Field name="save_as_new" component="input" type="checkbox" />
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={onClose}>Cancel</Button>
                <Button bsStyle="primary" type="submit">
                  Save Changes
                </Button>
              </Modal.Footer>
            </form>
          )}
        />
      </div>
    </Modal>
  );
};

CreateAlertModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  advancedSearch: PropTypes.object.isRequired,
};

CreateAlertModal.defaultProps = {
  show: false,
};

export default CreateAlertModal;



// WEBPACK FOOTER //
// ./src/pages/advancedSearch/Alerts/CreateAlertModal.jsx